import { RouteLocationNormalized } from 'vue-router'
import { displayOlark, hideOlark } from '@/lib/olark'

const enableLiveChat = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized
) => {
  const routeMeta = to.meta
  if (routeMeta && routeMeta.liveChatEnabled) {
    displayOlark()
  } else {
    hideOlark()
  }
}

export default enableLiveChat
